module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.companyClient.id) ? _c('div', {
    staticClass: "Typeahead user-caller-typeahead"
  }, [_c('div', {
    staticClass: "input-group  input-group-lg"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "caller-typeahead",
      "placeholder": "Anrufer suchen...",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        return _vm.down($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        return _vm.up($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.hit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.reset($event)
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }, _vm.update]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.companyClient.callerShowPeriod >= 0),
      expression: "companyClient.callerShowPeriod >= 0"
    }],
    staticClass: "btn ",
    class: {
      'btn-primary': _vm.callerShowPeriodFilterActive
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onClickCallerShowPeriodFilter
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-filter",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "title": "VIP und Mitarbeiter werden immer angezeigt"
    }
  }, [_vm._v(_vm._s(_vm.textCallerShowPeriod))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nothingFound),
      expression: "nothingFound"
    }],
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("Anrufer nicht gefunden")]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasItems),
      expression: "hasItems"
    }]
  }, _vm._l((_vm.items), function(item, index) {
    return _c('li', {
      class: _vm.activeClass(index),
      on: {
        "mousedown": _vm.hit,
        "mousemove": function($event) {
          return _vm.setActive(index)
        }
      }
    }, [_c('span', {
      staticClass: "name",
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(_vm.userType[item.idSex].sexText))
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "name",
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(item.firstName))
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "name",
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(item.lastName))
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.customerNumber),
        expression: "item.customerNumber"
      }],
      staticClass: "name"
    }, [_vm._v(", KdNr: ")]), _vm._v(" "), _c('span', {
      staticClass: "name",
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(item.customerNumber))
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.callerCity),
        expression: "item.callerCity"
      }],
      staticClass: "screen-name"
    }, [_vm._v(", (")]), _vm._v(" "), _c('span', {
      staticClass: "screen-name",
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(item.callerCity))
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.callerCity),
        expression: "item.callerCity"
      }],
      staticClass: "screen-name"
    }, [_vm._v(")")]), _vm._v(" "), (item.companyName) ? _c('span', [_c('span', {
      staticClass: "screen-name"
    }, [_vm._v("Fa. ")]), _vm._v(" "), _c('span', {
      staticClass: "screen-name",
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(item.companyName))
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "screen-name"
    }, [_vm._v(" (")]), _vm._v(" "), _c('span', {
      staticClass: "screen-name",
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(item.companyCity))
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "screen-name"
    }, [_vm._v(")")])]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "screen-name"
    }, [_vm._v(" " + _vm._s(item.callDateTimeBegin))]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "screen-phone",
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(item.phoneNumbers))
      }
    })]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "screen-info",
      domProps: {
        "textContent": _vm._s(item.info)
      }
    })])])
  }), 0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-search",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1e0c60c4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/UserCallerTypeahead.vue
// module id = 263
// module chunks = 0